import { ticketShopBaseUrl as baseURL } from '@/config/env'

export const shopUrl = (slug: string, code: string) => {
  if (slug.match(/^omr\d{2}$/)) {
    slug = 'festival'
  }
  return encodeURI(`${baseURL}/${slug}?promo_code=${code}`)
}
